import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import { MISSION_TYPE_PRESCRIPTION } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { MissionTypeName } from 'src/app/shared/enums/mission-type-name.enum';
import { Address } from 'src/app/shared/models/address';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { Employee } from 'src/app/shared/models/employee/employee';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { Specialite } from 'src/app/shared/models/specialite';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import * as _ from 'lodash'; // Importation de lodash
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-list-available-employees',
	templateUrl: './list-available-employees.component.html',
	styleUrls: ['./list-available-employees.component.scss'],
	standalone: true,
	imports: [CommonModule, RouterModule, FormsModule]
})
export class ListAvailableEmployeesComponent implements OnInit, OnChanges {
	@Input() date: Date;
	@Input() readyTime: Date;
	@Input() dueTime: Date;
	@Input() careSkills: CareSkill[];
	@Input() missionType: MissionType;
	@Input() specialty: Specialite;
	@Input() address: Address;
	@Input() isRemote: boolean;

	@Output() selectedEmployeeEmitter: EventEmitter<Employee> =
		new EventEmitter();
	selectedEmployee: Employee;

	employees: Employee[];

	constructor(private facade: FacadeService, private dateUtils: DateUtils) {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges) {
		let shouldResearch = false;

		for (let propName in changes) {
			if (changes.hasOwnProperty(propName)) {
				const change = changes[propName];

				if (propName === 'careSkills') {
					if (!_.isEqual(change.currentValue, change.previousValue)) {
						shouldResearch = true;
					}
				} else {
					shouldResearch = true;
				}

				if (shouldResearch) {
					this.employees = [];
					this.selectedEmployee = null;
					if (this.shouldResearchEmployees()) {
						this.searchBestEmployees();
					}
				}
			}
		}
	}

	searchBestEmployees(): void {
		const requiredDataForSearch: {
			date: Date;
			readyTime: number;
			dueTime: number;
			careSkills: CareSkill[];
			address: Address;
			isRemote: boolean;
			specialtyId?: number;
		} = {
			date: this.date,
			readyTime: this.dateUtils.convertFromDateToMinutes(this.readyTime),
			dueTime: this.dateUtils.convertFromDateToMinutes(this.dueTime),
			careSkills: this.careSkills,
			address: this.address,
			isRemote: this.isRemote
		};
		if (this.specialty) {
			requiredDataForSearch.specialtyId = this.specialty.id;
		}
		this.facade.parcoursService
			.searchBestEmployees(requiredDataForSearch)
			.subscribe((employees: Employee[]) => {
				this.employees = employees;
			});
	}

	getEntityNames(entities: { id: number; name: string }[]): string {
		return entities.map((entity) => entity.name).join(', ');
	}

	getCareSkills(careSkills: CareSkill[]): string {
		return careSkills.map((c) => c.name).join(', ');
	}

	onKeyDown(event: KeyboardEvent, emp: Employee) {
		if (event.key === 'Enter' || event.key === ' ') {
			this.selectEmployee(emp);
			event.preventDefault(); // Empêche le défilement de la page lorsque la barre d'espace est enfoncée
		}
	}

	selectEmployee(employee: Employee): void {
		if (this.selectedEmployee === employee) {
			this.selectedEmployee = null;
			this.selectedEmployeeEmitter.emit(null);
		} else {
			this.selectedEmployee = employee;
			this.selectedEmployeeEmitter.emit(this.selectedEmployee);
		}
	}

	shouldResearchEmployees() {
		const areCommonFieldsFilled =
			!!this.date &&
			!!this.readyTime &&
			!!this.dueTime &&
			!!this.careSkills &&
			!!this.missionType;
		const isAddressFilled =
			this.missionType?.type === MISSION_TYPE_PRESCRIPTION ||
			this.address ||
			this.isRemote;

		return areCommonFieldsFilled && isAddressFilled;
	}
}
